<template >
  <!-- https://vuetifyjs.com/en/components/text-fields/     :maxlength="formDetail.maxlength"-->
  <v-text-field
    :label="formDetail.title"
    :variant="formDetail.variant"
    v-model="tfValue"
    :rules="[rulesForm.required, rulesForm.minLength, rulesForm.maxlength, rulesForm.email]"
    :name="index"
  >
    <template v-slot:append-inner>
      <v-tooltip location="bottom" v-if="formDetail.description">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
        {{ formDetail.description }}
      </v-tooltip>
    </template>

  </v-text-field>
</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
const { $form} = useNuxtApp()
const rulesForm = $form.getRules(props.formDetail,props.index);

let tfValue = ref(props.model[props.index] ? props.model[props.index] : "");
</script>